<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 17C13.9882 17 15.6 15.3882 15.6 13.4H8.4C8.4 15.3882 10.0118 17 12 17Z" fill="black"/>
    <path d="M10.2 10.7C10.2 11.1971 9.79706 11.6 9.3 11.6C8.80294 11.6 8.4 11.1971 8.4 10.7C8.4 10.2029 8.80294 9.8 9.3 9.8C9.79706 9.8 10.2 10.2029 10.2 10.7Z" fill="black"/>
    <path d="M14.7 11.6C15.1971 11.6 15.6 11.1971 15.6 10.7C15.6 10.2029 15.1971 9.8 14.7 9.8C14.2029 9.8 13.8 10.2029 13.8 10.7C13.8 11.1971 14.2029 11.6 14.7 11.6Z" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M21 12.5C21 17.4706 16.9706 21.5 12 21.5C7.02944 21.5 3 17.4706 3 12.5C3 7.52944 7.02944 3.5 12 3.5C16.9706 3.5 21 7.52944 21 12.5ZM19.2 12.5C19.2 16.4764 15.9764 19.7 12 19.7C8.02355 19.7 4.8 16.4764 4.8 12.5C4.8 8.52355 8.02355 5.3 12 5.3C15.9764 5.3 19.2 8.52355 19.2 12.5Z" fill="black"/>
  </svg>
</template>

<script>
export default {
  name: 'smileIcon'
}
</script>

<style scoped>

</style>
